import CircularProgress from '@material-ui/core/CircularProgress';
import styles from '../../headerStyles';
import { withStyles } from '@material-ui/core';

const PublishProgressLoader = ({ classes }) => {
  return (
    <div className={classes.publishLoaderStyle}>
      <CircularProgress size={16} color="primary" thickness={5} />
    </div>
  );
};

export default withStyles(styles)(PublishProgressLoader);
